import { PageHeader } from '../shared/components/page-header'

export const TasksPage = () => {
  return (
    <div>
      <PageHeader header="Tasks in development" />
    </div>
  )
}
